// todo: consolidate this form and the one in react-sso-landing

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { loginSetFlowStageWatcher, loginWatcher } from "../../redux/actions/loginactioncreators";
import { FormattedMessage } from "react-intl";
import flowStages from "../../flowStages";
import { NewFADVLoginForm } from "../login/NewFADVLoginForm";


export function SkipChangeEmailAddress() {
  const dispatch = useDispatch();
  const challenge = useSelector(state => state.loginForm.challenge);
  const username = useSelector(state => state.loginForm.username);
  const password = useSelector(state => state.loginForm.password);
  const accountNumber = useSelector(state => state.loginForm.accountNumber);

  const handleCancel = () => {
    dispatch(loginSetFlowStageWatcher({
      flowStage: flowStages.EMAIL_NOT_VERIFIED,
    }));
  };

  const handleSubmit = () => {
    dispatch(loginWatcher({
      flowStage: flowStages.CHANGE_EMAIL_ADDRESS,
      username: username,
      password: password,
      accountNumber: accountNumber,
      challengeResponse: {
        session: challenge.session,
        challengeName: challenge.challengeName,
        challengeParameters: {
          USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
          SKIP: true
        }
      }
    }));
  };

  return (
    <NewFADVLoginForm
      onSubmit={handleSubmit}
      headerContent={
        <FormattedMessage
          id="login.skipEmailChangeTitle"
          defaultMessage="Are you sure?"
          description="Title for skip change email confirmation dialog"
        />
      }
      submitButtonText={<FormattedMessage id="login.skipEmailSubmit" defaultMessage="Skip This Step" description="Button to skip changing email address" />}
      secondaryButtonText={<FormattedMessage id="login.cancelSkipEmailSubmit" defaultMessage="Cancel" description="Button to cancel skipping email change" />}
      secondaryButtonHandler={handleCancel}
      secondaryButtonId="cancel"
    >
      <div className="mb-6">
        <FormattedMessage
          id="login.skipEmailChangeBlurb"
          defaultMessage="If you skip this step, and the username you provided is associated with an e-mail address already on file, you will need to contact customer support to change your password."
          description="Blurb for skip change email confirmation dialog"
        />
      </div>
    </NewFADVLoginForm>
  );
}